import { Platform } from 'react-native'

const trimTrailingSlash = (value: string) => value.replace(/\/+$/, '')

const defaultLocalBaseUrl = () => {
  if (Platform.OS === 'android') {
    return 'http://10.0.2.2:3337'
  }

  return 'http://127.0.0.1:3337'
}

export const resolveRelayablyInternalBaseUrl = () => {
  const explicitInternalUrl =
    typeof process !== 'undefined' ? process.env.EXPO_PUBLIC_RELAYABLY_INTERNAL_URL : undefined

  if (explicitInternalUrl) {
    return trimTrailingSlash(explicitInternalUrl)
  }

  const apiUrl = typeof process !== 'undefined' ? process.env.EXPO_PUBLIC_RELAYABLY_API_URL : undefined

  if (apiUrl) {
    return trimTrailingSlash(apiUrl).replace(/\/api$/, '/internal')
  }

  return defaultLocalBaseUrl()
}

export const buildRelayablyInternalUrl = (path: string) => {
  const baseUrl = resolveRelayablyInternalBaseUrl()

  if (baseUrl.endsWith('/internal') && path.startsWith('/internal/')) {
    return `${baseUrl}${path.slice('/internal'.length)}`
  }

  if (baseUrl.endsWith('/internal') && path === '/internal') {
    return baseUrl
  }

  return `${baseUrl}${path}`
}
